/* eslint-disable single-export/single-export */

import { NgModule } from '@angular/core';
import { AuthPipe, canActivate, customClaims } from '@angular/fire/compat/auth-guard';
import { Routes, RouterModule } from '@angular/router';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AdminUsersComponent } from './pages/admin-users/admin-users.component';
import { CmsComponent } from './pages/cms';
import { DeleteUserComponent } from './pages/delete-user/delete-user.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { StoresComponent } from './pages/stores/stores.component';

export const hasCustomClaimOrRedirect = (claim: string, redirect: string | string[]) =>
  pipe(
    customClaims as AuthPipe,
    map((claims) => (Object.prototype.hasOwnProperty.call(claims, claim) ? true : redirect))
  );

const adminOnly = () => hasCustomClaimOrRedirect('admin', ['login']);

const routes: Routes = [
  {
    ...canActivate(adminOnly),
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/home' },
      { component: HomeComponent, path: 'home' },
      { component: AdminUsersComponent, path: 'adminUsers' },
      { component: StoresComponent, path: 'stores' },
      { component: DeleteUserComponent, path: 'deleteUser' },
      { component: CmsComponent, path: 'media' },
    ],
    component: AppLayoutComponent,
    path: '',
  },
  {
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/login' },
      { component: LoginComponent, path: 'login' },
    ],
    component: AuthLayoutComponent,
    path: '',
  },
  {
    component: NotFoundComponent,
    path: '**',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
